var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"&scroll":function($event){return _vm.handleScroll.apply(null, arguments)}}},[_c('the-header',{attrs:{"show-searchbar":_vm.showSearchbar}}),_c('div',{staticClass:"router-wrapper"},[_c('router-view')],1),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }